<template>
   <b-modal :id="id" ref="contactModal" :ok-only="submitSuccess" :title="`Message for article: ${article.name}`">
      <template slot="modal-footer">
         <b-button variant="secondary" @click="$refs.contactModal.hide()">
            CANCEL
         </b-button>
         <pb-btn :busy="submitProcessing" variant="primary"
                 v-on:click.native="onSubmit">
            {{ submitSuccess ? 'OK' : 'SEND' }}
         </pb-btn>
      </template>
      <b-container class="text-left">
         <b-row>
            <b-col v-if="submitSuccess">
               <p><i class="fas fa-check-circle text-success"></i>We will process your request as quickly as possible.
               </p>
            </b-col>
            <b-col v-else>
               <b-form @submit="onSubmit">
                  <b-row class="my-2" v-if="submitError">
                     <b-col>
                        <b-alert variant="danger" show>{{ submitError }}</b-alert>
                     </b-col>
                  </b-row>
                  <b-row class="my-2">
                     <b-col>
                        <label for="reason">Contact Reason:</label>
                        <v-select id="country"
                                  :clearable="false"
                                  name="reason"
                                  :reduce="reason => reason.value"
                                  placeholder="Please select reason..."
                                  v-validate="'required'"
                                  v-bind:class="[{'is-invalid': errors.has('reason')}, 'secondary']"
                                  v-model="formData.selectedReason"
                                  :options="contactReason">
                        </v-select>
                     </b-col>
                  </b-row>
                  <b-row class="my-2">
                     <b-col>
                        <label for="requestBody">Request:</label>
                        <b-form-textarea
                            id="requestBody"
                            name="requestBody"
                            v-validate="'required'"
                            v-bind:class="[{'is-invalid': errors.has('requestBody')}, 'h-auto secondary']"
                            v-model.trim="formData.requestBody"
                            rows="5"
                            placeholder="Please specificy your request here..."
                            no-resize
                        ></b-form-textarea>
                     </b-col>
                  </b-row>
               </b-form>
               <b-row class="p-2" v-if="article.contactRequests">
                  <b-col>
                     <b-row :key="item.id" v-for="(item) in article.contactRequests">
                        <b-col>
                           <b-row>
                              <b-col>
                                 {{ new Date(item.createDateTime).toLocaleDateString() }}
                              </b-col>
                           </b-row>
                           <b-row>
                              <b-col>
                                 {{ item.text }}
                              </b-col>
                              <hr class="w-100 m-2"/>
                           </b-row>
                        </b-col>
                     </b-row>
                  </b-col>
               </b-row>
            </b-col>
         </b-row>


      </b-container>
   </b-modal>
</template>
<script>

import ContactApi from "@shared/_api/contact";

function initialData(defaultReason) {
   return {
      submitSuccess: false,
      submitProcessing: false,
      submitError: null,
      formData: {
         requestBody: null,
         selectedReason: defaultReason ? defaultReason : null
      }
   }
}

export default {
   name: 'contact-modal',
   props: {
      id: String,
      subject: String,
      article: Object,
      defaultReason: String
   },
   data() {
      return {
         contactReason: [
            {label: 'Please note our article code:', value: 0},
            {label: 'Please note our color code:', value: 1},
            {label: 'Price missing', value: 2},
            {label: 'Request long term decleration', value: 3},
            {label: 'Other:', value: 4}
         ],
         ...initialData()
      };
   },
   methods: {
      show() {
         this.$refs.contactModal.show()
      },
      resetData(defaultReason) {
         this.$validator.reset().finally(() => {
            Object.assign(this.$data, initialData(defaultReason));
         });
      },
      onSubmit(evt) {
         evt.preventDefault();
         this.submitError = null;
         if (this.submitSuccess) {
            this.$nextTick(() => {
               this.$emit('ok');
               this.$refs.contactModal.hide();
            })
         } else {
            this.$validator.validate().then(valid => {
               if (valid) {
                  this.submitProcessing = true;
                  this.formData.clientUrl = window.location.origin + "/activate/";
                  ContactApi.post({
                     text: this.formData.requestBody,
                     subject: `${this.subject} | ${this.contactReason[this.formData.selectedReason].label}`,
                     articleId: this.article ? this.article.id : null
                  }).then((requestObj) => {
                     if (this.article.contactRequests) {
                        this.article.contactRequests.unshift(requestObj);
                     } else {
                        this.article.contactRequests = [];
                        this.article.contactRequests.push(requestObj);
                     }
                     this.submitSuccess = true;
                  }).catch(() => {
                     this.submitError = "An error occured. Please contact our customer support.";
                  }).finally(() => {
                     this.submitProcessing = false;
                  });
               }
            });
         }
      },
      validateState(ref) {
         if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.errors.has(ref)
         }
         return null
      },
   }
}
</script>